import { Article } from '@/shared/components/article';
import MoySkladIcon from '@/shared/components/icons/moysklad-icon';
import OZONIcon from '@/shared/components/icons/ozon-icon';
import TochkaIcon from '@/shared/components/icons/tochka-icon';
export const Partners = () => {
  return <Article>
      <h2 className="mb-16 header-h2 md:mb-32">Нам доверяют</h2>

      <div className="grid grid-cols-1 gap-x-4 gap-y-12 md:grid-cols-3 md:gap-x-6">
        <div className="mx-auto max-w-80">
          <div className="h-12 md:h-20">
            <OZONIcon className="mx-auto" />
          </div>

          <h3 className="mb-2 text-center header-h3">Официальный партнер</h3>

          <p className="text-center text-muted-foreground">
            Проводим корпоративные занятия по&nbsp;английскому языку для сотрудников Ozon
          </p>
        </div>

        <div className="mx-auto max-w-80">
          <div className="h-12 md:h-20">
            <TochkaIcon className="mx-auto text-black dark:text-white" />
          </div>

          <h3 className="mb-2 text-center header-h3">Официальный партнер</h3>

          <p className="text-center text-muted-foreground">
            Проводим индивидуальные занятия по&nbsp;английскому языку для сотрудников Точка банка
          </p>
        </div>

        <div className="mx-auto max-w-80">
          <div className="h-12 md:h-20">
            <MoySkladIcon className="mx-auto block" />
          </div>

          <h3 className="mb-2 text-center header-h3">Официальный партнер</h3>

          <p className="text-center text-muted-foreground">
            Проводим индивидуальные занятия по&nbsp;английскому языку для сотрудников компании Мой Склад
          </p>
        </div>
      </div>
    </Article>;
};